import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useScrollToTop } from "./hooks/useScrollToTop";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import Availability from "./pages/Availability";
import Locations from "./pages/Locations";
import LocationDetail from "./pages/LocationDetail";
import HowItWorks from "./pages/HowItWorks";
import AboutUs from "./pages/AboutUs";
import Community from "./pages/Community";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LegalTerms from "./pages/LegalTerms";
import StandardBuildingPolicy from "./pages/StandardBuildingPolicy";
import PropertyManagement from "./pages/PropertyManagement";

function ScrollToTop() {
  useScrollToTop();
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/availability" element={<Availability />} />
        <Route path="/our-locations" element={<Locations />} />
        <Route path="/our-locations/:slug" element={<LocationDetail />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/community" element={<Community />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/legal-terms" element={<LegalTerms />} />
        <Route path="/standard-building-policy" element={<StandardBuildingPolicy />} />
        <Route path="/property-management" element={<PropertyManagement />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}